import {
    apiRequest,
    mappingPegawaiDetail, 
    mappingPegawaiUpdate,
} from "../../../../../../services/adapters/master/refMesinAbsenMappingPegawaiService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", mappingPegawaiDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", mappingPegawaiUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository